import  { useContext, useEffect, useState } from "react";
import Button from "../../../components/atoms/Button";
import styles from "./index.module.css";
import { json, useLocation, useNavigate, useParams } from "react-router-dom";
import InputText from "../../../components/atoms/InputText";
import { Box, Typography, } from "@mui/material";
import Modal from "@mui/material/Modal";
import IconButton from "@mui/material/IconButton";
import ClearIcon from "@mui/icons-material/Clear";
import Label from "../../../components/atoms/Label";
import ArrowLeft from "../../../images/icons/arrow_left.svg";
import Navbar from "../../../components/molecules/Navbar";
import Footer from "../../../components/molecules/Footer";
import FeemonkText from "../../../components/atoms/FeemonkText";
import { DataContext } from "../../../context/DataContext";
import { DataContextType } from "../../../types/DataContextType";
import { createApplication } from "../../../services/application";
import axios from "axios";
import moment from "moment";
import { ApplicantStage } from "../../../utils/applicationStage";
import { encode } from "punycode";
import axiosInstance from "../../../../helpers/axios";

function EnterPanIndividualPage() {
  const location = useLocation()
  const pathSegments = window.location.pathname.split('/');
  const encodedData = pathSegments[pathSegments.length - 1];
  const data = sessionStorage.getItem("data") || encodedData 
  const [loading,setLoading] = useState(false)
  const [geolocation, setLocation] = useState({
    latitude: 0,
    longitude: 0,
  });
  console.log("location--->",location.state)
  const navigate = useNavigate();
  // const { data } = useParams();
  const [panData, setPanData] = useState({})
  let [userData, setUserData] = useState<{
    application:string,
    dob:string,
    applicationId: string;
    userId: string;
    email: string;
    panId: string;
    dateOfBirth: string;
    instituteId: string;
    firstName: string;
    lastName: string;
    mobile: string;
    course: string;
    fees: number;
    studentName: string;
    instituteName: string;
    redirectUrl: string;
    channelId: number;
    flow:string;
    courseFees: number;
    courseName?: string;
    merchantId?: string;
  }>({
    application:'',
    applicationId: "",
    userId: "",
    instituteId: "",
    firstName: "",
    lastName: "",
    panId: "",
    dateOfBirth: "",
    dob:'',
    email: "",
    mobile: "",
    course: "",
    fees: 0,
    studentName: "",
    instituteName: "",
    redirectUrl: "",
    channelId: 0,
    flow:'',
    courseFees: 0,
    courseName: "",
    merchantId: "",
  });

  const [pan, setPan] = useState('');
  const [dob, setDob] = useState("");
  const { updatePanProData, saveIds } = useContext(
    DataContext
  ) as DataContextType;

  const [position, setPosition] = useState<{
    latitude: number | null;
    longitude: number | null;
  }>({ latitude: null, longitude: null });

  const [error, setError] = useState("");  
  useEffect(() => {
    // Try to decode data from the URL first; if not present or invalid,
    // fall back to any encoded token stored in sessionStorage.
    const tryDecode = (encoded: string | null) => {
      if (!encoded) return null;
      try {
        const jsonData = atob(encoded);
        const parsed = JSON.parse(jsonData);
        return { encoded, parsed };
      } catch (err) {
        return null;
      }
    };

    let decoded = tryDecode(data);
    if (!decoded) {
      const stored = sessionStorage.getItem("data");
      decoded = tryDecode(stored);
    }

    if (decoded) {
      // Only set session storage when the data is a valid encoded payload
      sessionStorage.setItem("data", decoded.encoded);
      setUserData(decoded.parsed);

      // Only call getPanDetails when we have both userId and applicationId
      if (decoded.parsed?.userId && decoded.parsed?.applicationId) {
        getPanDetails();
      } else {
        console.log("Skipping getPanDetails: missing userId or applicationId", decoded.parsed);
      }
    } else {
      console.log("No valid encoded data available, skipping getPanDetails");
    }
  }, []);
  console.log("data--->",data,userData)
  // If navigation passed data via location.state, prefer that to prefill form fields
  useEffect(() => {
    try {
      const locState: any = (location as any).state || null;
      // prefer location.state.data when present
      const locData: any = locState && locState.data ? locState.data : locState;
      if (locData) {
        // set userData from location.state.data
        setUserData((prev) => ({ ...prev, ...locData }));

        // Prefill PAN if available in pan_details array
        const panFromLoc = locData?.pan_details?.[0]?.pan_number || locData?.panId || locData?.pan || locData?.pan_number;
        if (panFromLoc) setPan(String(panFromLoc).toUpperCase());

        // Prefill DOB: prefer personal_details.dob, then other common keys
        const rawDob = locData?.personal_details?.dob || locData?.dateOfBirth || locData?.dob || locData?.date_of_birth || '';
        if (rawDob) {
          // normalize to YYYY-MM-DD for input[type=date]
          let iso = rawDob;
          // if in DD-MM-YYYY or DD/MM/YYYY convert
          if (/^\d{2}[-/]\d{2}[-/]\d{4}$/.test(rawDob)) {
            const parts = rawDob.split(/[-/]/);
            iso = `${parts[2]}-${parts[1]}-${parts[0]}`;
          }
          setDob(iso);
        }
      }
    } catch (err) {
      // ignore
    }
  }, [location]);
useEffect(() => {
  let decodedData: any = {};
  
  if (data) {
    try {
      const jsonData = atob(data);
      decodedData = JSON.parse(jsonData);
      
      // Set session storage
      sessionStorage.setItem("source", decodedData.page || "checkout");
      
      console.log("decodedData-->", decodedData);
      
      // Ensure we have required fields before making API calls
      if (!decodedData.applicationId) {
        console.error("applicationId is missing from decoded data");
        return;
      }
      
      if (!decodedData.mobile) {
        console.error("mobile is missing from decoded data");  
        return;
      }
      
    } catch (error) {
      console.error("Error decoding data:", error);
      return; // Exit early if decoding fails
    }
  } else {
    console.error("No encoded data provided");
    return;
  }

  // Check previous applications
  checkPreviousApplications(decodedData);
  
  // Check application stage  
  checkApplicationStage(decodedData);
  
}, []);
  // Re-check stage and previous applications when navigation/location changes
  useEffect(() => {
    try {
      const raw = sessionStorage.getItem("data") || (pathSegments && pathSegments[pathSegments.length - 1]);
      if (!raw) return;
      const jsonData = JSON.parse(atob(raw));
      if (!jsonData?.applicationId || !jsonData?.userId) return;
      checkPreviousApplications(jsonData);
      checkApplicationStage(jsonData);
    } catch (err) {
    }
  }, [location]);
const checkPreviousApplications = (checkoutData: any) => {
  fetch(
    `${process.env.REACT_APP_BASE_URL}/applications/getApplications/${checkoutData.mobile}`
  )
  .then((res) => res.json())
  .then((response) => {
    const prevApplication = response?.res?.pop()?.obj?.data;
    if (prevApplication) {
      userData = { ...prevApplication, existing: true, flow: checkoutData?.flow };
    }
    
    const { panId, dateOfBirth } = prevApplication || {};
    
    // Fix: Use checkoutData.email instead of checkoutData.studentEmail
    if (panId && dateOfBirth && (checkoutData?.email || checkoutData?.studentEmail)) {
      const customerDashboardLoginUrl = `${process.env.REACT_APP_DASHBOARD_URL}/login/admin`;
      const payLoad = {
        mobile: checkoutData?.mobile,
      };
      
      axiosInstance.post(customerDashboardLoginUrl, payLoad, {
        headers: {
          Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiI3Yjc1ZDkwMy1kYWJmLTQ1NzEtOTA1Mi02MWM4MjU0MDMwMDQiLCJtb2JpbGUiOiIyMjIyMjIyMjIzIiwic3RhdHVzIjoiQWRtaW4iLCJuYW1lIjoiUGF5TGF0ZXIiLCJyb2xlIjoiYWRtaW4iLCJpYXQiOjE3NTAzMTcxNTEsImV4cCI6MTc1MDMzNTE1MX0.DAldhpnUQyihDJa_II3dLn8Xr7GSllopu6cZsQKTS1E`
        }
      })
      .then((res) => {
        console.log("responseee login", res?.data?.data);
        window.open(`${process.env.REACT_APP_FRONTEND_URL}/login/admin?mob=${checkoutData?.mobile}&data=${res?.data?.data}`, '_self');
      })
      .catch((error) => console.log(error, "error"));
    }
    
    console.log(prevApplication, 'prevApplication');
  })
  .catch((err) => console.log(err));
};
const checkApplicationStage = (checkoutData: any) => {
  // Add validation before making API call
  if (!checkoutData.applicationId) {
    console.error("Cannot check application stage: applicationId is missing");
    return;
  }
  
  console.log("Checking stage for applicationId:", checkoutData.applicationId); // Debug log
  
  fetch(
    `${process.env.REACT_APP_DASHBOARD_URL}/admin/application/stage?applicationId=${checkoutData.applicationId}`
  )
  .then((res) => {
    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }
    return res.json();
  })
  .then((res) => {
     if (res?.data?.stage) {
              console.log(res?.data, 'stage data')
              switch (res?.data?.stage) {
                case ApplicantStage.PanVerification:
                  navigate("/address-details", {
                    state: { data: userData },
                  });
                  break;
                case ApplicantStage.EmploymentDetails:
                  navigate("/work-details", { state: { data: userData } });
                  break;
                case ApplicantStage.AddressDetails:
                  navigate("/address-details", { state: { data: userData } });
                  break;
                case ApplicantStage.BankStatement:
                  navigate("/view-offers", { state: { data: userData } });
                  break;
                case ApplicantStage.AwaitingApproval:
                  navigate("/parking-page", { state: { data: userData } });
                  break;
                case ApplicantStage.CoapplicantRequired:
                  navigate("/parking-page", { state: { data: userData } });
                  break;
                case ApplicantStage.AwaitingCoapplicantConsent:
                  navigate("/parking-page", { state: { data: userData } });
                  break;
                case ApplicantStage.Approved:
                  navigate("/select-emi", { state: { data: userData } });
                  break;
                case ApplicantStage.SanctionTermsAccepted:
                  navigate("/sanctions", { state: { data: userData } });
                  break;
                case ApplicantStage.Digilocker:
                  navigate("/sanctions", { state: { data: userData } });
                  break;
                case ApplicantStage.Selfie:
                  navigate("/sanctions", { state: { data: userData } });
                  break;
                case ApplicantStage.Agreement:
                  navigate("/sanctions", { state: { data: userData } });
                  break;
                case ApplicantStage.BankAccountVerified:
                  navigate("/sanctions", { state: { data: userData } });
                  break;
                case ApplicantStage.Mandate:
                  navigate("/pf-collection", { state: { data: userData } });
                  break;
                case ApplicantStage.PFCollections:
                  navigate("/pf-collection", { state: { data: userData } });
                  break;
                case ApplicantStage.ProcessComplete:
                  navigate("/disbursed-page", { state: { data: userData } });
                  break;
                case ApplicantStage.Disbursed:
                  navigate("/disbursed-page", { state: { data: userData } });
                  break;
                case ApplicantStage.Rejected:
                  navigate("/rejected-page", { state: { data: userData } });
                  break;
                default:
                  navigate(`/pan-details/:data`);
                  break;
              }
            } else {
      console.log("No stage data found in response");
    }
  })
  .catch((error) => {
    console.error("Error checking application stage:", error);
    // Handle error appropriately - maybe show user message or redirect to default page
  });
};


  const [openedModal, setOpened] = useState<boolean>(false); // Define open state variable

  const [checked, setChecked] = useState(false);
  
 const getPanDetails = async () => {
  try {
    const getData: any = atob(data);
    const parsedData = JSON.parse(getData);
    const { applicationId, userId } = parsedData;

    // Guard: do not call API if required ids are missing
    if (!applicationId || !userId) {
      console.log("getPanDetails: missing applicationId or userId, skipping API call.", parsedData);
      return;
    }

    console.log("Getting PAN details for:", { applicationId, userId }); // Debug log

    const response = await axios(
      `${process.env.REACT_APP_DASHBOARD_URL}/summary/user?id=${userId}&applicationId=${applicationId}`
    );

    console.log(response, 'response');

    if (response?.status === 200) {
      const { panId, dateOfBirth } = response?.data?.data;
      setPan(panId || '');
      setDob(dateOfBirth || '');
    }
  } catch (error) {
    console.log("Error getting PAN details:", error);
  }
};
  const handleCheck = (event: any) => {
    setChecked(event);
  };

  const handleCloseConsent = () => setOpened(false);

  const [link, setLink] = useState("");

  const handleStartSession = (value: any) => {
    console.log("exe");
    const randomGen =
      Date.now().toString(36) + Math.random().toString(36).substr(2);

    (window as any)
      .getBureauSession(
        process.env.REACT_APP_CONSENT_KEY,
        randomGen,
        value.firstName,
        "",
        value.lastName,
        value.mobile
      )
      .then((res: any) => {
        console.log(res);
        setOpened(true)
        setLink(res);
      });
  };

  const handleLoadSession = async () => {
    const result = await (window as any).startBureauSession();
    sessionStorage.setItem("data",data)
   
    const jsonData =JSON.parse(atob(data))
    console.log(data, 'data',jsonData )
    let passData: any ={}
    if(jsonData?.flow ==='apply-now'){
      passData = {...panData, fees:jsonData.fees,
                    instituteName: jsonData.instituteName, 
                    course: jsonData.course, channelId:jsonData.channelId, 
                    flow:jsonData?.flow,
                    application:jsonData?.applicationId,
                    userId:jsonData?.userId
                  }
    }
    else{
      passData={...panData, courseFees:jsonData?.courseFees,
         instituteName: jsonData.instituteName, course: jsonData.course, 
         channelId:jsonData.channelId, flow:jsonData?.flow, email: jsonData?.studentEmail, studentName:jsonData?.studentName,
         application:jsonData?.applicationId,
         userId:jsonData?.userId
        }
    }
    if (result) {
      switch (result.status) {
       
        case "SUCCESS":
          
          try{
            const res = await axios.get( `${process.env.REACT_APP_DASHBOARD_URL}/rules/eligibility?phone=${userData?.mobile}`)
            const qecBody = {
              applicationId: userData.application,
              userId: userData.userId,
              instituteId: userData.instituteId,
              studentName: userData.firstName + " " +  userData.lastName  ,
              applicantName: userData.firstName + " " +  userData.lastName,
              panId: userData.panId,
              dob: moment(userData.dob).format("DD/MM/YYYY"),
              phone: userData.mobile,
              status: "Created",
              eligibility: res?.data?.data?.status,
            };
            let authToken;
            if(res?.data?.data?.status === 3 || res?.data?.data?.status === 1){
              try {
                const response1 = await fetch(
                  `${process.env.REACT_APP_DASHBOARD_URL}/login/auth`,
                  {
                    method: "POST",
                    body: JSON.stringify({
                      memberId: userData?.userId ? userData?.userId: jsonData?.userId,
                    }),
                    headers: {
                      "Content-Type": "application/json",
                    },
                  }
                );
          
                const result1 = await response1.json();
                authToken = result1.data;
              } catch (error) {
                 console.log(error)
              }
              try {
                const summaryData = {
                  userId : userData?.userId,
                  applicationId: userData?.applicationId,
                  channel:212,
                };
                const headers = {
                  Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiI3Yjc1ZDkwMy1kYWJmLTQ1NzEtOTA1Mi02MWM4MjU0MDMwMDQiLCJtb2JpbGUiOiIyMjIyMjIyMjIzIiwic3RhdHVzIjoiQWRtaW4iLCJuYW1lIjoiUGF5TGF0ZXIiLCJyb2xlIjoiYWRtaW4iLCJpYXQiOjE3NTAzMTcxNTEsImV4cCI6MTc1MDMzNTE1MX0.DAldhpnUQyihDJa_II3dLn8Xr7GSllopu6cZsQKTS1E`,
                  "Content-Type": "application/json",
                };
                axios.post( `${process.env.REACT_APP_DASHBOARD_URL}/summary/update`,
                  summaryData,
                    { headers }
                  )
                  .then(() => {
                  })
                  .catch((error) => console.log("error", error));
              } catch (error) {
                console.log(error)
              }
              try {
                const data = {
                  userId : jsonData?.userId,
                  latitude: geolocation.latitude,
                  longitude: geolocation.longitude,
                };
                const headers = {
                  Authorization: `Bearer ${authToken}`,
                  "Content-Type": "application/json",
                };
                axios.post( `${process.env.REACT_APP_DASHBOARD_URL}/end-user/submit/app`,
                    data,
                    { headers }
                  )
                  .then(() => {
                  })
                  .catch((error) => console.log("error", error));
              } catch (error) {
                console.log(error)
              }
 
              await axios.post(
                  `${process.env.REACT_APP_DASHBOARD_URL}/rules/create/eligibility`,
                  qecBody
                )
                .then((result: any) => {
                  console.log(result)
                })
                .catch((err) => {
                  console.log(err);
                });

                navigate("/address-details", { state: { data:passData}});
            }
            else{
              navigate("/rejected-page", { state: { data: userData } });
            }
        
          }catch(e){
            console.log(e, 'eligibility err')
          }
          
          break;

        case "EXIT":
          alert("Retry Submit");
          handleCloseConsent();
          break;

        case "ERROR":
          alert("Error Please Try Later");
          handleCloseConsent();
          break;

        default:
          alert("Contact our team for assistance");
          break;
      }
    }
  };


  const submitApplicationToInReview = async (panResponse: any) => {
    sessionStorage.setItem("data",data)
    const jsonData =JSON.parse(atob(data))
    const panData = panResponse;
    console.log("panData",panData)
    let passData: any ={}
    if(jsonData?.flow ==='apply-now'){
      passData = {
        ...panData, fees:jsonData.fees,
        instituteName: jsonData.instituteName, 
        course: jsonData.course, channelId:jsonData.channelId, 
        flow:jsonData?.flow,
        application:jsonData?.applicationId,
        userId:jsonData?.userId
      }
    }
    else{
      passData={
        ...panData,
        courseFees:jsonData?.courseFees || jsonData?.fees,
        instituteName: jsonData.instituteName,
        course: jsonData.course, 
        channelId:jsonData.channelId,
        flow:jsonData?.flow,
        email: jsonData?.email,
        studentName:jsonData?.studentName,
        application:panData.application || jsonData?.applicationId,
        userId:jsonData?.userId
      }
    }
    if(userData.channelId !== 12){
 try{
      const res = await axios.get( `${process.env.REACT_APP_DASHBOARD_URL}/rules/eligibility?phone=${userData?.mobile}`)
      const qecBody = {
        applicationId: userData.application,
        userId: userData.userId,
        instituteId: userData.instituteId,
        studentName: userData.firstName + " " +  userData.lastName  ,
        applicantName: userData.firstName + " " +  userData.lastName,
        panId: userData.panId,
        dob: moment(userData.dob).format("DD/MM/YYYY"),
        phone: userData.mobile,
        status: "Created",
        eligibility: res?.data?.data?.status,
      };
      let authToken;
      if(res?.data?.data?.status === 3 || res?.data?.data?.status === 1){
        try {
          const response1 = await fetch(
            `${process.env.REACT_APP_DASHBOARD_URL}/login/auth`,
            {
              method: "POST",
              body: JSON.stringify({
                memberId: userData?.userId ? userData?.userId: jsonData?.userId,
              }),
              headers: {
                "Content-Type": "application/json",
              },
            }
          );
    
          const result1 = await response1.json();
          authToken = result1.data;
        } catch (error) {
            console.log(error)
        }
        try {
          const response1 = await fetch(
              `${process.env.REACT_APP_DASHBOARD_URL}/login/auth`,
              {
                method: "POST",
                body: JSON.stringify({
                  memberId: userData?.userId ? userData?.userId: jsonData?.userId,
                }),
                headers: {
                  "Content-Type": "application/json",
                },
              }
            );
      
            const result1 = await response1.json();
            authToken = result1.data;
          const summaryData = {
            userId : userData?.userId,
            applicationId: userData?.applicationId,
            channel:userData?.channelId?userData?.channelId:2,
          };
          const headers = {
            Authorization: `Bearer ${authToken}`,
            "Content-Type": "application/json",
          };
          axios.post( `${process.env.REACT_APP_DASHBOARD_URL}/summary/update`,
            summaryData,
              { headers }
            )
            .then(() => {
            })
            .catch((error) => console.log("error", error));
        } catch (error) {
          console.log(error)
        }
        try {
          const data = {
            userId : jsonData?.userId,
            latitude: geolocation.latitude,
            longitude: geolocation.longitude,
          };
          const headers = {
            Authorization: `Bearer ${authToken}`,
            "Content-Type": "application/json",
          };
          axios.post( `${process.env.REACT_APP_DASHBOARD_URL}/end-user/submit`,
              data,
              { headers }
            )
            .then(() => {
            })
            .catch((error) => console.log("error", error));
        } catch (error) {
          console.log(error)
          alert("Error in Submitting your application, Contact our team for assistance");
        }

        await axios.post(
            `${process.env.REACT_APP_DASHBOARD_URL}/rules/create/eligibility`,
            qecBody
          )
          .then((result: any) => {
            console.log(result)
          })
          .catch((err) => {
            console.log(err);
          });

          navigate("/address-details", { state: { data:passData}});
      }
      else{
        navigate("/rejected-page", { state: { data: userData } });
      }
  
    }catch(e){
      console.log(e, 'eligibility err')
      alert("Error in Processing your request, Contact our team for assistance");
    }
    }
    else{
     navigate("/address-details", { state: { data:passData}});
    }
   
          
  };
  
  const  success = (position: any) =>{
    const latitude = position.coords.latitude;
    const longitude = position.coords.longitude;
    setLocation({ latitude,longitude});
  }
  const handleVerify = () => {
    setLoading(true)
    const locationData: any = (location && (location as any).state && (location as any).state.data) || {};

    const mobileToSend = locationData.mobile || userData?.mobile || '';

    const rawDob = dob || locationData.dob || userData?.dob || '';
    const formattedDob = rawDob ? moment(rawDob, ['YYYY-MM-DD', 'DD-MM-YYYY', 'DD/MM/YYYY']).format('DD/MM/YYYY') : '';

    const userIdToSend = locationData.id || userData?.userId || '';
    const channelIdToSend = locationData.channelId || userData?.channelId || 0;

    createApplication(
      {
        mobile: mobileToSend,
        panId: pan,
        dob: formattedDob,
        channelId: channelIdToSend,
        userId: userIdToSend,
        courseFees: userData?.courseFees,
        courseName: userData?.courseName,
        merchantId: userData?.merchantId
      },
      '',
      userData?.flow
    )
      .then((result) => {
        console.log(result, 'pan result');
        if (result.message !== "Successful") {
              console.log("Error", result.message);

              setError(result.data || result.message);
              setLoading(false);
              return;
            }
            if (result?.data === "Date of Birth not matching") {
              console.log("Error", result.data); 
              setLoading(false);
              setError(result.data);
              return;
            }
            
            setPanData(result.data)
            setUserData(result.data)
            submitApplicationToInReview(result.data)
      })
      .catch((err) => console.error(err));
  }
  const getPanPro = () => {
    console.log("Clicked", userData);
    setLoading(true)
    // TODO: Send longitude and latitude to the backend from here.

    // Latitude: {position.latitude}, Longitude: {position.longitude}

    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(function (position) {
        success(position)
        console.log(userData, 'userData');
        createApplication({
          mobile: userData?.mobile,
          panId: pan,
          dob:moment(dob, 'YYYY-MM-DD').format('DD/MM/YYYY'),
          channelId:userData?.channelId,
          userId:userData.userId,
          applicationId: userData.applicationId
        }, '', userData?.flow)
          .then((result) => {
            if (result.message !== "Successful") {
              console.log("Error", result.message);

              setError(result.data || result.message);
              return;
            }
            if (result?.data === "Date of Birth not matching") {
              console.log("Error", result.data); 

              setError(result.data);
              return;
            }
            
            setPanData(result.data)
            setUserData(result.data)
            // handleStartSession(result.data)
            submitApplicationToInReview(result.data)
            setLoading(false)
          })
          .catch((err) => {
            console.log(err);
            setError("PAN not verified");
            setLoading(false)
          });
      });
    } else {
      console.log("Geolocation is not available in your browser.");
      alert("Please enable location services to proceed");
      setLoading(false)
    }
  };
  const formatToDisplayFormat = (isoDate: string) => {
  if (!isoDate) return '';
  const [year, month, day] = isoDate.split('-');
  return `${day}-${month}-${year}`; // or whatever format you prefer
};
  
  return (
    <div className={styles.body}>
      {error && (
        <div
          style={{
            position: "fixed",
            top: "0",
            left: "0",
            width: "100%",
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: "1000",
          }}
          onClick={() => setError("")}
        >
          <div
            style={{
              backgroundColor: "white",
              padding: "1rem 1rem",
              borderRadius: "10px",
              boxShadow: "0 0 10px rgba(0,0,0,0.3)",
              margin: "0 1rem",
              
            }}
            onClick={() => setError("")}
          >
            <h5
              style={{
                fontFamily: "Outfit",
                textAlign: "center",
                fontSize:'16px'
              }}
            >
              <span style={{color:'#d32028'}}>Error:{' '}</span>{error}
            </h5>
          </div>
        </div>
      )}
      <>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={openedModal}
          keepMounted
          closeAfterTransition
        >
          <Box
            display="flex"
            justifyContent="center"
            flexDirection="column"
            alignItems="center"
          >
            <Box
              display="flex"
              justifyContent="center"
              gap="40%"
              alignItems="center"
              style={{
                width: "371px",
                backgroundColor: "white",
                padding: "10px",
              }}
            >
              <Typography
                id="modal-modal-title"
                variant="h6"
                component="h2"
                sx={{
                  fontWeight: "500",
                  fontSize: "20px",
                }}
              >
                OTP Consent
              </Typography>
              <IconButton
                style={{ border: "2px solid #DbDbDb", width: "40px" }}
                aria-label="remove"
                size="small"
                onClick={handleCloseConsent}
              >
                <ClearIcon />
              </IconButton>
            </Box>

            <Box display="flex" justifyContent="center" alignItems="center">
              <iframe
                width="370"
                height="630"
                src={link}
                onLoad={handleLoadSession}
                title="bureau"
              ></iframe>
            </Box>
          </Box>
        </Modal>
      </>
     

      <div className={styles.backdrop}>
        <Navbar />
        <div className={styles.container}>
          <div className={styles.content}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                
              }}
            >
              <Label text="PAN number" left />
              <InputText
                square
                placeholder="PAN Number"
                changeHandler={(e) => setPan(e.target.value.toUpperCase())}
                value={pan}
              />
              <br />
              <Label text="Date Of Birth" left />
              <InputText
                square
                placeholder="Date of Birth"
                 changeHandler={(e) => {
                  const isoDate = e.target.value; 
                  setDob(isoDate); 
                }}
                value={dob}
                type="date"
              />
              <br />
             
            </div>
            <br/>
            {userData?.channelId !== 12 ? <>
             <div
              style={{
                display:'flex',
              }}
            >
              <input
                type="checkbox"
                onChange={(e: any) => handleCheck(e.target.checked)}
                style={{
                  marginRight: "10px",
                  height: "25px",
                  width: "25px",
                }}
                checked={checked}
              />
              <p className={styles.consentText}>
                I consent and authorize <FeemonkText /> to get a background
                check and a consumer credit report on me.
              </p>
            </div>
            </> : null}
           
          </div>
          <Button
            onPress={() => {
              userData?.channelId ===12 ? handleVerify():getPanPro();
            }}
            imageRight={ArrowLeft}
            text={loading?"Verifying..":"Verify"}
            disabled={userData?.channelId === 12 ?!pan || !dob: !checked || !pan || !dob}
            insureFin={userData?.channelId === 5}
          />
        </div>
        <br />
        <Footer />
      </div>
    </div>
  );
}

export default EnterPanIndividualPage;
